// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueWait from 'vue-wait';

import EntityPerimeter from '@/kindergarten/perimeters/EntityPerimeter';

import './plugins/vuex';
import './plugins/vue-toasted';
import './plugins/axios';
import './plugins/vee-validate';
import './plugins/vue-progress';
import { i18n } from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/bootstrap';
import './plugins/vue-kindergarten';
import './plugins/font-awesome';
import './plugins/vue-quill-editor';

import './assets/scss/main.scss';

import App from './App';
import store from './store';

Vue.use(VueWait);

Vue.config.productionTip = false;

store.dispatch('auth/check');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  perimeters: [
    EntityPerimeter,
  ],
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  wait: new VueWait({
    useVuex: true,
  }),
});



// WEBPACK FOOTER //
// ./src/main.js